import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { consumePendingReturnTo } from "./Auth0Provider";

export function LoginCallback() {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const returnTo = consumePendingReturnTo() ?? "/dashboard";
      // Parse out the pathname so query strings don't get baked into `to`,
      // which TanStack treats as a literal route path.
      let pathname = returnTo;
      try {
        pathname = new URL(returnTo, window.location.origin).pathname;
      } catch {
        pathname = "/";
      }
      void navigate({ to: pathname });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (error) {
    return (
      <div
        role="alert"
        className="min-h-screen flex items-center justify-center bg-surface text-error"
      >
        Sign-in failed: {error.message}
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-screen flex items-center justify-center bg-surface text-on-surface-variant"
    >
      Completing sign in...
    </div>
  );
}
